import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { StyledChip, ChipText } from './styles';
import { Icon } from '../Icon';
export var Chip = function (_a) {
  var label = _a.label,
    _b = _a.isSelected,
    isSelected = _b === void 0 ? false : _b,
    icon = _a.icon,
    onClick = _a.onClick;
  var theme = useTheme();
  return _jsxs(StyledChip, {
    onClick: onClick,
    isSelected: isSelected,
    hasIcon: icon !== undefined,
    children: [icon && _jsx(Icon, {
      size: 16,
      type: icon,
      color: isSelected ? theme.tokens.accent.onToken.secondary.regular : theme.tokens.accent.token.secondary.regular
    }), _jsx(ChipText, {
      el: "p",
      styleName: "labelSmall",
      isSelected: isSelected,
      children: label
    })]
  });
};